import { Routes } from '@angular/router';
import { loggedInAuthGuard } from '@guards/logged-in-auth.guard';
import { isStorePreview } from './features/wheel-store/store-preview';
import { isEngineWheel } from './features/engine/engine-route';

export const APP_ROUTES: Routes = [
  {
    path: 'engine',
    canMatch: [isEngineWheel],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'play' },
      {
        path: ':tab',
        loadComponent: () =>
          import('./features/wheel-store/wheel-store.component').then(
            (m) => m.WheelStoreComponent,
          ),
      },
    ],
  },
  {
    path: 'preview',
    canMatch: [isStorePreview],
    children: [
      { path: '', pathMatch: 'full', redirectTo: 'play' },
      {
        path: ':tab',
        loadComponent: () =>
          import('./features/wheel-store/wheel-store.component').then(
            (m) => m.WheelStoreComponent,
          ),
      },
    ],
  },
  {
    path: '',
    children: [
      {
        path: 'm',
        loadChildren: () =>
          import('./features/mobile/mobile.routes').then(
            (m) => m.MOBILE_ROUTES,
          ),
      },
      {
        path: 'd',
        loadChildren: () =>
          import('./features/desktop/desktop.routes').then(
            (m) => m.DESKTOP_ROUTES,
          ),
      },
    ],
    canActivate: [loggedInAuthGuard],
  },
  {
    path: 'error',
    loadComponent: () =>
      import('./features/error/error.component').then((m) => m.ErrorComponent),
  },
  {
    path: '**',
    redirectTo: '',
  },
];
